import { useState } from 'react'
import { useContext } from 'react'
import { ModalContext, ModalKey } from 'components/Modals/ModalContext'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid'

import StatusIndicatorV5 from 'components/ActiveWorkoutV5/StatusIndicatorV5'
import LoadAssignedV5 from 'components/ActiveWorkoutV5/LoadAssignedV5'
import VolumeAssignedV5 from 'components/ActiveWorkoutV5/VolumeAssignedV5'
import LoadCompletedV5 from 'components/ActiveWorkoutV5/LoadCompletedV5'
import VolumeCompletedV5 from 'components/ActiveWorkoutV5/VolumeCompletedV5'
import ActionButtonsV5 from 'components/ActiveWorkoutV5/ActionButtonsV5'
import GroupIndividualExerciseSetListItemV5 from 'components/ActiveWorkoutV5/GroupIndividualExerciseSetListItemV5'

export default function ExerciseSetListItemV5({ 
    exerciseHashMap = {},
    kinesisWorkoutAssignmentType = 'individual',
    groupIndividuals = [],
    phaseIndex = 0, 
    phase = {},
    slotIndex = 0, 
    slot = {}, 
    setIndex = 0, 
    set = {},
    CalculateWeightRecommendations = () => {},
    OnSwapButton = null,
    OnUndoSwapButton = null
}) {
    const { ShowModal } = useContext(ModalContext)

    const [expandGroupAthletes, setExpandGroupAthletes] = useState(false)

    const ShowExerciseInstructionsModal = () => {
        const modalData = {
            key: ModalKey.ExerciseInstructions,
            fullscreen: true,
            exerciseId: slot.exerciseId
        }

        ShowModal(modalData)
    }

    if (Object.keys(exerciseHashMap).length === 0) { 
        return (
            <div className='w-full h-32 p-4'>
                <div className='w-full h-full bg-gray-200 rounded-lg animate-pulse' />
            </div>
        )
    }

    const exercise = exerciseHashMap[slot.exerciseId] ?? null
    const isCompleted = set.completed
    const isSkipped = set.skipped

    if (
        phase.expanded === false
        || exercise === null
    ) {
        return null
    }

    return (
        <div>
            <div className='pt-2 px-4 pb-2 flex items-center gap-x-2 h-12'>
                <StatusIndicatorV5 
                    isCompleted={isCompleted} 
                    isSkipped={isSkipped} 
                />

                <p className='text-xl flex-grow'>
                    {exercise.name}
                </p>
            </div>

            <div className='w-full px-4 pb-4 flex items-center gap-x-4'>
                <div className='space-y-2'>
                    <div className='text-xs text-center text-gray-600'>Instructions</div>

                    <div 
                        className="w-20 h-20 bg-gray-200 rounded-lg overflow-hidden flex-shrink-0 cursor-pointer"
                        onClick={ShowExerciseInstructionsModal}
                    >
                        <img 
                            src={exercise.imageUrl} 
                            alt={exercise.name}
                            className="w-full h-full object-cover"
                        />
                    </div>
                </div>

                <LoadAssignedV5 
                    exercise={exercise} 
                    set={set} 
                    isSkipped={isSkipped} 
                    isCompleted={isCompleted} 
                />
                
                <VolumeAssignedV5 
                    exercise={exercise} 
                    set={set} 
                    isSkipped={isSkipped} 
                    isCompleted={isCompleted} 
                />

                <div className='flex-1' />

                <LoadCompletedV5
                    kinesisWorkoutAssignmentType={kinesisWorkoutAssignmentType}
                    groupIndividual={null} // Only set this for the group-individual set item
                    phaseIndex={phaseIndex}
                    slotIndex={slotIndex}
                    exercise={exercise}
                    setIndex={setIndex}
                    set={set}
                    isCompleted={isCompleted}
                    isSkipped={isSkipped}
                /> 
                
                <VolumeCompletedV5
                    kinesisWorkoutAssignmentType={kinesisWorkoutAssignmentType}
                    groupIndividual={null} // Only set this for the group-individual set item
                    phaseIndex={phaseIndex}
                    slotIndex={slotIndex}
                    exercise={exercise}
                    setIndex={setIndex}
                    set={set}
                    isCompleted={isCompleted}
                    isSkipped={isSkipped}
                />

                <ActionButtonsV5
                    kinesisWorkoutAssignmentType={kinesisWorkoutAssignmentType}
                    groupIndividual={null} // Only set this for the group-individual set item
                    phaseIndex={phaseIndex}
                    slotIndex={slotIndex}
                    exercise={exercise}
                    setIndex={setIndex}
                    set={set}
                    isCompleted={isCompleted}
                    isSkipped={isSkipped}
                    slot={slot}
                    CalculateWeightRecommendations={CalculateWeightRecommendations}
                    OnSwapButton={OnSwapButton}
                    OnUndoSwapButton={OnUndoSwapButton}
                /> 

                {kinesisWorkoutAssignmentType === 'group' && groupIndividuals?.length > 1 && (
                    <div 
                        className='pr-3 cursor-pointer pt-6'
                        onClick={() => setExpandGroupAthletes(!expandGroupAthletes)}
                    >
                        {!expandGroupAthletes && <ChevronDownIcon className='w-8 h-8 text-gray-600' />}
                        {expandGroupAthletes && <ChevronUpIcon className='w-8 h-8 text-gray-600' />}
                    </div>
                )}
            </div>

            <div className='divide-y divide-gray-200'>
                {(
                    kinesisWorkoutAssignmentType === 'group' 
                    && groupIndividuals?.length > 1
                    && expandGroupAthletes 
                ) && groupIndividuals.map((groupIndividual, index) => (
                    <div 
                        key={index} 
                        className={`
                            w-full bg-gray-50 flex items-center pr-4 gap-x-4
                            ${groupIndividual?.workout?.phases[phaseIndex]?.slots[slotIndex]?.sets[setIndex]?.groupIndividualOverride ? 'bg-orange-100' : ''}
                        `}
                    >
                        <GroupIndividualExerciseSetListItemV5
                            kinesisWorkoutAssignmentType='group-individual'
                            groupIndividual={groupIndividual}
                            phaseIndex={phaseIndex}
                            slotIndex={slotIndex}
                            exercise={exercise}
                            setIndex={setIndex}
                            set={set}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}